import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import "@/assets/css/style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap"; //bootstrap JS
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "@/assets/css/header.css";

router.beforeEach((to, from, next) => {
  // Set the document title from the route meta or a default fallback
  document.title = to.meta.title || "Poorent";
  next(); // Continue to the next middleware or route
});

createApp(App).use(router).mount("#app");
